import { createAction } from 'deox';
import {
  GET_REFUNDS_REQUEST,
  GET_REFUNDS_SUCCESS,
  GET_REFUNDS_FAILURE,
  CREATE_REFUND_REQUEST,
  CREATE_REFUND_SUCCESS,
  CREATE_REFUND_FAILURE,
  RETRIEVE_REFUND_REQUEST,
  RETRIEVE_REFUND_SUCCESS,
  RETRIEVE_REFUND_FAILURE,
  UPLOAD_ATTACHMENTS_REQUEST,
  UPLOAD_ATTACHMENTS_SUCCESS,
  UPLOAD_ATTACHMENTS_FAILURE,
  AttachmentDTO,
  RefundDTO,
} from './types';

// Экшен для получения списка возвратов
export const getRefundsAction = {
  request: createAction(GET_REFUNDS_REQUEST),
  success: createAction(GET_REFUNDS_SUCCESS, resolve => (data: RefundDTO[]) => resolve(data)),
  failure: createAction(GET_REFUNDS_FAILURE, resolve => (error: string) => resolve(error)),
};

// Экшен для создания нового возврата
export const createRefundAction = {
  request: createAction(
    CREATE_REFUND_REQUEST,
    resolve => (data: Partial<RefundDTO>) => resolve(data),
  ),
  success: createAction(CREATE_REFUND_SUCCESS, resolve => (data: RefundDTO) => resolve(data)),
  failure: createAction(CREATE_REFUND_FAILURE, resolve => (error: string) => resolve(error)),
};

// Экшен для получения конкретного возврата по ID
export const refundDetailsAction = {
  request: createAction(RETRIEVE_REFUND_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(RETRIEVE_REFUND_SUCCESS, resolve => (data: RefundDTO) => resolve(data)),
  failure: createAction(RETRIEVE_REFUND_FAILURE, resolve => (error: string) => resolve(error)),
};

// Экшен для загрузки вложений
export const uploadAttachmentsAction = {
  request: createAction(
    UPLOAD_ATTACHMENTS_REQUEST,
    resolve => (files: File[]) => resolve({ files }),
  ),
  success: createAction(
    UPLOAD_ATTACHMENTS_SUCCESS,
    resolve => (data: AttachmentDTO[]) => resolve(data),
  ),
  failure: createAction(UPLOAD_ATTACHMENTS_FAILURE, resolve => (error: string) => resolve(error)),
};
